import * as Const from './const.js';

export default {
  load() {
    $('.videos-slides')
      .slick({
        arrows: true,
        centerMode: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: '<a href="#" class="slick-prev"><i class="fas fa-arrow-left d-sm-none"></i><i class="fas fa-chevron-left d-none d-sm-block"></i></a>',
        nextArrow: '<a href="#" class="slick-next"><i class="fas fa-arrow-right d-sm-none"></i><i class="fas fa-chevron-right d-none d-sm-block"></i></a>',
        responsive: [{
          breakpoint: Const.$grid.lg,
          settings: {
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }],
      })
      .on('beforeChange', function() {
        $('.yt-player').each(function(){
          this.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
        });
      });
  },

  handleVideo(playerStatus) {
    if (playerStatus === -1) {
      // unstarted
      $('.videos-slides').slick('slickPause');
    } else if (playerStatus === 0) {
      // ended
      $('.videos-slides').slick('slickPlay');
    } else if (playerStatus === 1) {
      // playing = green
      $('.videos-slides').slick('slickPause');
    } else if (playerStatus === 2) {
      // paused = red
      $('.videos-slides').slick('slickPlay');
    } else if (playerStatus === 3) {
      // buffering = purple
    } else if (playerStatus === 5) {
      // video cued
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/util/slider.js